<template>
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <div class="ccui-app-iframe-container-detail">
        <div class="ccui-app-iframe-container-detail-body">
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">
                {{ tabName }}
              </el-button>
            </div>
            <template v-if="!isRemoveMaxAndMin && isCheckedHighAndLow">
              <div class="fr remarkTip">
                少于5个专家提交评分，系统不再进行去掉最低分和最高分操作
              </div>
              <div class="clearfix"></div>
            </template>
          </div>
          <el-table :data="listData" border>
            <template v-for="(item, index) in columns">
              <el-table-column
                :key="index"
                :show-overflow-tooltip="true"
                v-bind="item"
                v-if="item.labelChild && item.labelChild.length > 0"
              >
                <template slot="header">
                  <template v-if="item.required">
                    <span class="star">*</span>
                  </template>
                  {{ item.label }}
                </template>
                <template v-if="item.labelChild && item.labelChild.length > 0">
                  <el-table-column
                    v-for="(child, indexch) in item.labelChild"
                    :key="indexch"
                    align="center"
                    v-bind="child"
                  >
                    <template slot="header">
                      <div class="el-tooltip">{{ child.label }}</div>
                    </template>
                  </el-table-column>
                  <template slot-scope="scope">
                    <span v-if="child.money">{{
                      scope.row[child.prop] !== ""
                        ? new BigNumber(scope.row[child.prop]).toFormat(2)
                        : ""
                    }}</span>
                    <span v-else>{{ scope.row[child.prop] }}</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :show-overflow-tooltip="true"
                v-bind="item"
                v-else-if="!item.labelChild"
              >
                <template slot="header">
                  <template v-if="item.required">
                    <span class="star">*</span>
                  </template>
                  {{ item.label }}
                </template>
                <template slot-scope="scope">
                  <el-select
                    v-if="item.type == 'select' && type == '0'"
                    v-model="scope.row[item.prop]"
                  >
                    <el-option value="1" label="淘汰"></el-option>
                    <el-option value="0" label="不淘汰"></el-option>
                  </el-select>
                  <template v-else-if="item.prop === 'lostReason'">
                    <el-input
                      maxlength="1000"
                      show-word-limit
                      class="input-short word-limit input-width;"
                      v-if="
                        item.type == 'input' &&
                          type == '0' &&
                          scope.row.lostFlag === '1'
                      "
                      v-model="scope.row[item.prop]"
                    ></el-input>
                    <span v-else>-</span>
                  </template>
                  <span v-else-if="item.money">{{
                    scope.row[item.prop] !== ""
                      ? new BigNumber(scope.row[item.prop]).toFormat(2)
                      : ""
                  }}</span>
                  <span v-else>{{ scope.row[item.prop] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <!--          </el-tab-pane>-->
          <!--        </el-tabs>-->
        </div>
      </div>
      <div class="operate">
        <el-button
          type="text"
          icon="icon-ccui-save"
          v-preventReClick
          @click="save"
          >保存</el-button
        >
        <el-button type="text" icon="icon-ccui-cancel" @click="back"
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQrySumScoreCalculateApi,
  scpDealSumScoreSaveApi,
  scpListPurchaseSchemePackageApi,
  scpQryScoreListApi,
  scpQrySupComCheckListApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

export default {
  name: "supOperateSkillOrCommonSummary",
  components: {
    breadcrumbSourcing
  },
  data() {
    let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      getqrySupComCheckList: [],
      BigNumber: BigNumber,
      breadcrumbData: {
        titname:
          JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
            .evaMethod === "103"
            ? "商务评分汇总"
            : this.$router.history.current.query.type == 0
            ? "技术评分汇总"
            : "商务技术评分汇总"
      },
      type: this.$router.history.current.query.type, // 0：技术汇总 1：商务技术汇总1
      listData: [],
      skillHeaders: [],
      commonHeader: [],
      supScoreIds: [],
      columns: [],
      columnCopy: [
        {
          prop: "id",
          label: "序号",
          width: 55,
          fixed: true
        },
        {
          prop: "supName",
          label: "分包商",
          width: 200,
          fixed: true
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        {
          prop: "taxAmount",
          label: "税额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          width: 200,
          align: "right",
          money: true
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术加分项",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务加分项",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "投标报价",
          labelChild: [],
          align: "center"
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 110
        }
        // {
        //   prop: "lostFlag",
        //   label: "是否淘汰",
        //   width: 110,
        //   type: "select",
        //   required: true
        // },
        // {
        //   prop: "lostReason",
        //   label: "淘汰理由",
        //   width: 350,
        //   type: "input",
        //   required: true
        // }
      ],
      packName: "",
      subPackageFlag: "1", // 是否分包 1分包0不分包
      isRemoveMaxAndMin: false,
      tabName: "",
      isCheckedHighAndLow: false // 是否选中了去除技术评分的最高最低
    };
  },
  created() {
    console.log(1111222);
    scpQrySupComCheckListApi({
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      systemFlag: 0,
      joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .joinExpertId,
      purStep: this.$router.history.current.query.menuKey,
      evaPurStep: this.$router.history.current.query.evaPurStep
    }).then(res => {
      if (res.data.code === "0") {
        this.getqrySupComCheckList = res.data.data.rows;
        // 通过包件id进行排序
        console.log("data", res.data.data.rows);
        console.log("getqrySupComCheckList", this.getqrySupComCheckList);
      }
    });
  },

  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      this.columnCopy.splice(4, 1);
      this.columns = this.columnCopy;
    } else {
      this.columns = this.columnCopy;
    }
    this.getData();
    this.getPackData();
  },
  methods: {
    getData() {
      scpQryScoreListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        purStep: this.$router.history.current.query.evaPurStep,
        // evaPurStep: this.$router.history.current.query.evaPurStep,
        // purStep: this.$router.history.current.query.menuKey,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.data) {
          this.isCheckedHighAndLow = res.data.data.sumForm === "102";
        }
      });
      scpQrySumScoreCalculateApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.$router.history.current.query.packId,
        scoreItem: this.$router.history.current.query.type == 1 ? "" : "0",
        isShowPageLoading: true
      }).then(res => {
        if (res.data.data) {
          this.isRemoveMaxAndMin = res.data.data.isRemoveMaxAndMin;
        }
        if (
          res.data.data &&
          res.data.data.sscSumScoreCalculateBOS &&
          res.data.data.sscSumScoreCalculateBOS.length > 0
        ) {
          if (this.type == 1) {
            // if (this.purchaseType == "50" || this.purchaseType == "53") {
            //   this.columns.splice(3, 0, {
            //     prop: "sscCommonScoreItemBOS",
            //     label: "商务",
            //     labelChild: [],
            //     align: "center"
            //   });
            // } else {
            //   this.columns.splice(4, 0, {
            //     prop: "sscCommonScoreItemBOS",
            //     label: "商务",
            //     labelChild: [],
            //     align: "center"
            //   });
            // }
          } else {
            this.columns.push(
              {
                prop: "lostFlag",
                label: "是否淘汰",
                width: 110,
                type: "select",
                required: true
              },
              {
                prop: "lostReason",
                label: "淘汰理由",
                width: 350,
                type: "input",
                required: true
              }
            );
          }
          let labelChild = []; // 商务
          let labelSkillChild = []; // 技术
          let bidChild = []; // 投标报价
          let labelSkillChild2 = []; // 技术加分项
          let labelSkillChild3 = []; // 商务加分项
          res.data.data.sscSumScoreCalculateBOS.forEach((item, index) => {
            item.id = index + 1;
            item.sscSupScoreBOS.forEach(aItem => {
              aItem.sscSupScoreItemBOS.forEach(bItem => {
                if (!bItem.supScore) {
                  bItem.supScore = 0;
                }
                item.scoreRule = bItem.scoreRule;
                let props =
                  "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId;
                item[props] =
                  bItem.supScore && new BigNumber(bItem.supScore).toFormat(2);
                if (this.type == 1) {
                  if (aItem.scoreItem === "1") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ===
                          "supScore-" +
                            aItem.scoreItem +
                            "-" +
                            bItem.scoreItemId
                        );
                      }).length === 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 120,
                        type: "input"
                      });
                    }
                  }
                }

                if (aItem.scoreItem === "0") {
                  if (
                    labelSkillChild.filter(item => {
                      return (
                        item.prop ===
                        "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId
                      );
                    }).length === 0
                  ) {
                    labelSkillChild.push({
                      prop: props,
                      label: bItem.scoreRule,
                      width: 120,
                      type: "input"
                    });
                  }
                }
                if (aItem.scoreItem === "5") {
                  if (
                    bidChild.filter(item => {
                      return (
                        item.prop ===
                        "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId
                      );
                    }).length === 0
                  ) {
                    bidChild.push({
                      prop: props,
                      label: bItem.scoreRule,
                      width: 120,
                      type: "input"
                    });
                  }
                }
                if (aItem.scoreItem === "2") {
                  if (
                    labelSkillChild2.filter(item => {
                      return (
                        item.prop ===
                        "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId
                      );
                    }).length === 0
                  ) {
                    labelSkillChild2.push({
                      prop: props,
                      label: bItem.scoreRule,
                      width: 120,
                      type: "input"
                    });
                  }
                }
                if (aItem.scoreItem === "3") {
                  if (
                    labelSkillChild3.filter(item => {
                      return (
                        item.prop ===
                        "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId
                      );
                    }).length === 0
                  ) {
                    labelSkillChild3.push({
                      prop: props,
                      label: bItem.scoreRule,
                      width: 120,
                      type: "input"
                    });
                  }
                }
              });
            });
          });
          if (this.purchaseType == "50" || this.purchaseType == "53") {
            this.columns[4].labelChild = labelSkillChild;
            if (this.type == 1) {
              this.columns[7].labelChild = labelChild;
            }
          } else {
            this.columns[7].labelChild = labelSkillChild;
            this.columns[8].labelChild = labelSkillChild2;
            this.columns[9].labelChild = labelChild;
            this.columns[10].labelChild = labelSkillChild3;
            this.columns[11].labelChild = bidChild;
          }

          this.supScoreIds = res.data.data.supScoreIds;
          this.listData = res.data.data.sscSumScoreCalculateBOS;
        }
      });
    },
    getPackData() {
      scpListPurchaseSchemePackageApi({
        pageNo: -1,
        pageSize: -1,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        let packId = this.$router.history.current.query.packId;
        res.data.data.purchaseSchemePackageList.forEach(item => {
          if (item.packId == packId) {
            this.packName = item.packName;
          }
        });
        let name = this.subPackageFlag == "1" ? `(包件：${this.packName})` : "";
        this.$set(
          this,
          "tabName",
          `${
            JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
              .evaMethod === "103"
              ? "商务评分汇总"
              : this.type == 0
              ? "技术评分汇总"
              : "商务技术评分汇总"
          }${name}`
        );
      });
    },
    save() {
      let sscSupScoreSumBOS = [];
      let flag = true;
      let message = "";
      try {
        this.listData.forEach((item, index) => {
          console.log(item.lostFlag);
          if (this.type == "0") {
            if (item.lostFlag === "" || item.lostFlag === undefined) {
              flag = false;
              message = "第" + (index + 1) + "行的是否淘汰不能为空！";
              throw Error();
            }
            if (!item.lostReason && item.lostFlag === "1") {
              flag = false;
              message = "第" + (index + 1) + "行的淘汰理由不能为空！";
              throw Error();
            }
          }
          let obj = {};
          obj.supCode = item.supCode;
          obj.supName = item.supName;
          obj.supScore = item.supScore;
          obj.lostFlag = item.lostFlag;
          obj.lostReason = item.lostReason;
          obj.busiSumScore = 0;
          obj.techSumScore = 0;
          obj.busiExtraSumScore = 0; //商务加分项汇总评分
          obj.techExtraSumScore = 0; //技术加分项汇总评分
          obj.sscSupScoreSumItemBOS = [];
          item.sscSupScoreBOS.forEach(sscSupScoreBO => {
            sscSupScoreBO.sscSupScoreItemBOS.forEach(sscSupScoreItemBO => {
              let sscSupScoreSumItemBO = {};
              sscSupScoreSumItemBO.scoreItem = sscSupScoreBO.scoreItem;
              sscSupScoreSumItemBO.scoreItemId = sscSupScoreItemBO.scoreItemId;
              sscSupScoreSumItemBO.scoreRule = sscSupScoreItemBO.scoreRule;
              sscSupScoreSumItemBO.supScore = sscSupScoreItemBO.supScore;
              if (sscSupScoreBO.scoreItem === "0") {
                obj.techSumScore += sscSupScoreItemBO.supScore;
              }
              if (sscSupScoreBO.scoreItem === "1") {
                obj.busiSumScore += sscSupScoreItemBO.supScore;
              }
              if (sscSupScoreBO.scoreItem === "2") {
                obj.techExtraSumScore += sscSupScoreItemBO.supScore;
              }
              if (sscSupScoreBO.scoreItem === "3") {
                obj.busiExtraSumScore += sscSupScoreItemBO.supScore;
              }
              obj.sscSupScoreSumItemBOS.push(sscSupScoreSumItemBO);
            });
          });
          sscSupScoreSumBOS.push(obj);
        });
      } catch (e) {
        console.log(e);
      }
      if (flag) {
        let param = {
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.$router.history.current.query.packId,
          packName: this.packName,
          supScoreIds: this.supScoreIds,
          sumScoreType: this.type == 0 ? 0 : 2,
          sscSupScoreSumBOS: sscSupScoreSumBOS,
          isShowLoading: true
        };
        // let obj = [];
        console.log(param);
        console.log(this.listData);
        param.sscSupScoreSumBOS.forEach(item => {
          let index = this.listData.findIndex(
            ele => item.supCode == ele.supCode
          );
          item.noTaxPriceAmount = this.listData[index].noTaxPriceAmount;
          item.priceAmount = this.listData[index].priceAmount;
          item.supJoinId = this.listData[index].supJoinId;
          item.supPackQuoteId = this.listData[index].supPackQuoteId;
          item.supQuoteId = this.listData[index].supQuoteId;
          item.taxAmount = this.listData[index].taxAmount;
        });
        console.log("param", param);
        /*  let a = true;
        if (a) {
          true;
        } */
        scpDealSumScoreSaveApi(param).then(res => {
          if (res.data.code == "0") {
            this.$router.push({
              name:
                this.type == 1
                  ? "scpSummaryBusinessSkillsScores"
                  : "scpTechnicalScoreSummary",
              query: {
                a: this.$router.history.current.query.a,
                menuKey: this.$router.history.current.query.menuKey,
                evaPurStep: this.$router.history.current.query.evaPurStep
              }
            });
            this.$message({
              message: "保存成功",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        });
      } else {
        this.$message({
          message: message,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    back() {
      console.log(this.type);
      this.$router.push({
        name:
          this.type == 1
            ? "scpSummaryBusinessSkillsScores"
            : "scpTechnicalScoreSummary",
        query: {
          a: this.$router.history.current.query.a,
          menuKey: this.$router.history.current.query.menuKey,
          evaPurStep: this.$router.history.current.query.evaPurStep
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}

.remarkTip {
  color: #ff142f;
  margin-top: 19px;
}
/deep/ .el-table td {
  padding: 0 !important;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
</style>
